"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _TeamsIntegrationModalHeader = require("./TeamsIntegrationModalHeader");
Object.keys(_TeamsIntegrationModalHeader).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _TeamsIntegrationModalHeader[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _TeamsIntegrationModalHeader[key];
    }
  });
});